<template>
  <b-modal ref="exim-popup" id="exim-popup" hide-footer title="" size="xl">
    <div class="d-block text-left mb-5 p-2 pt-0" v-if="!isAuthenticated">
      <h1>Hitelre van szüksége?</h1>
      A Vali.hu-n személyre szabottan megtalálja a Széchenyi Kártya Program, az EXIM, és az MFB által kínált új termékek
      széles körét. Éljen a lehetőséggel és lépjen be a Vali fiókjába vagy
      <router-link to="/register">regisztráljon</router-link>.
      <br />
      <br />
      <b-button class="mt-4" variant="primary" @click="showLoginModal">Bejelentkezés</b-button>
    </div>
    <div class="d-block text-left mb-5 p-2 pt-0" v-if="isAuthenticated">
      <h1>Hitelre van szüksége?</h1>
      A Vali.hu-n személyre szabottan megtalálja a Széchenyi Kártya Program, az EXIM, és az MFB által kínált új
      termékeket.
      <br />
      <br />
      <b-button class="mt-4" variant="primary" @click="nextPage">Tovább a lehetőségekhez</b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EximPopup',
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    showLoginModal() {
      this.$refs['exim-popup'].hide()
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    nextPage() {
      this.$refs['exim-popup'].hide()
      this.$router.push('/company-offers-private')
    }
  }
}
</script>

<style scoped>
::v-deep #exim-popup .modal-content {
  background-color: #00903c;
  color: white;

  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-color: #00903c;
}

::v-deep #exim-popup .modal-header {
  border-bottom: 0px;
}

h1 {
  color: white;
}

.btn {
  border: 2px solid white;
  min-width: 250px;
}

a {
  color: white;
  text-decoration: underline;
}
</style>
